import { createAction } from '@reduxjs/toolkit';

export const scheduleUpdate = createAction('[Schedules] scheduleUpdate');
export const resetSchedule = createAction('[Schedules] resetSchedule');
